import React, { useState, useEffect } from "react";
import { UTILS } from "../config/API"

const CheckboxField = ({ field, formData, handleCheckboxGroupChange, picklistCache, setPicklistCache }) => {
  const [checkboxOptions, setCheckboxOptions] = useState([]);
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);

  // Fetch checkbox options when the component mounts or when itemvaluegroup changes
  useEffect(() => {
    const fetchCheckboxOptions = async () => {
      if (field.fieldtype === "checkbox" && field.itemvaluegroup) {
        // Check if options are already cached
        if (picklistCache[field.itemvaluegroup]) {
          setCheckboxOptions(picklistCache[field.itemvaluegroup]);
          return;
        }

        setIsDropdownLoading(true);
        try {
          const response = await fetch(UTILS, {
            method: "POST",
            headers: { 
              "Content-Type": "application/x-www-form-urlencoded",
              "Accept": "application/json" // Explicitly request JSON
            },
            body: new URLSearchParams({
              action: "idv",
              s: field.itemvaluegroup,
            }),
          });

          const data = await response.json();
          if (response.ok) {
            setCheckboxOptions(data);
            setPicklistCache((prevCache) => ({
              ...prevCache,
              [field.itemvaluegroup]: data,
            }));
          } else {
            throw new Error("Failed to fetch checkbox options");
          }
        } catch (error) {
          console.error("Error fetching checkbox options:", error);
        } finally {
          setIsDropdownLoading(false);
        }
      }
    };

    fetchCheckboxOptions();
  }, [field.itemvaluegroup, picklistCache, setPicklistCache]);

  return (
    <div className="space-y-2">
      {isDropdownLoading ? (
        <p>Loading options...</p>
      ) : (
        <div className="flex flex-wrap gap-4">
          {checkboxOptions.map((option) => (
            <div key={option.valuetext} className="flex items-center">
              <input
                type="checkbox"
                name={field.fieldname}
                value={option.valuetext}
                checked={(formData[field.fieldname] || []).includes(option.valuetext)}
                onChange={(e) => handleCheckboxGroupChange(e, field.fieldname)}
                className="w-5 h-5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
              />
              <span className="ml-2 text-gray-700">{option.valuetext}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CheckboxField;